import { render, staticRenderFns } from "./SurveyAnswersAcceptanceModal.vue?vue&type=template&id=2bfb0fe3"
import script from "./SurveyAnswersAcceptanceModal.vue?vue&type=script&lang=ts"
export * from "./SurveyAnswersAcceptanceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports